import create from "zustand";

interface Modal {
  modalContent: null | React.ReactNode;
  setModalContent: (content: null | React.ReactNode) => void;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
}

export const useModal = create<Modal>(set => ({
  modalContent: null,
  setModalContent: content =>
    set(() => ({
      modalContent: content,
    })),
  showModal: false,
  setShowModal: value => set(() => ({ showModal: value })),
}));
